/**
 * @module registration/creative/components/step2
 */

import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { browserHistory } from 'react-router';
import TopProgressBar from 'common/components/top_progress_bar';
import Substep2_1 from 'registration/creative/containers/substep2_1';
import Substep2_2 from 'registration/creative/containers/substep2_2';
import Substep2_3 from 'registration/creative/containers/substep2_3';
import Substep2_4 from 'registration/creative/containers/substep2_4';
import cookie from 'react-cookie';


/* definition of substeps */
const substeps = [
  { id: "settings", title: "Account Info", icon: "cog", component: Substep2_1 },
  { id: "verify", title: "Verify ID", icon: "eye", component: Substep2_2 },
  { id: "profile", title: "Submit Samples", icon: "user", component: Substep2_3 },
  { id: "review", title: "Review", icon: "check", component: Substep2_4 }
];

/**
 * Second step of creative registration.
 * This step is composed of several substeps.
 * Check the substeps definition above for more details.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class Step2 extends Component {
  componentDidMount() {
    /* Handle user coming from phone validation magic link */
    if (cookie.load('resume_registration_from_magic_link') === 'true') {
      const startedOnMobile = cookie.load('magic_link_sent_from_mobile') === 'true'
      cookie.remove('resume_registration_from_magic_link', {path: '/'})
      cookie.remove('magic_link_sent_from_mobile', {path: '/'})
      this.props.resumeFromMagicLink(startedOnMobile)
    }

    this.props.fetchIdPhotoIfNeeded().then(status => {
      /* redirect user to ID verification screen if registration is not open */
      if (!['draft', 'waiting_for_creative'].includes(status)) {
        browserHistory.push("/account/id-verification")
      }
    })
  }

  render() {
    const { substep, magicLinkSentFromMobile } = this.props;
    const substepIdx = substeps.findIndex((s) => s.id == substep);
    const Substep = substeps[substepIdx].component;

    return (
      <div id="content" className="l-content registration creative step2">

        {/* Hide progress bar if only capturing the ID photo and selfie via the magic
            link and the user is supposed to get back to desktop after that. */}
        {magicLinkSentFromMobile !== false &&
        <TopProgressBar steps={substeps} currentStep={substepIdx} currentSubstep={0}/>}

        <ReactCSSTransitionGroup
          className="transition-group"
          transitionName="substep"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}>
          <div className="substep-wrapper" key={substep}>
            <Substep/>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

Step2.propTypes = {
  substep: PropTypes.string,
  resumeFromMagicLink: PropTypes.func,
  magicLinkSentFromMobile: PropTypes.bool,
}

export default Step2;



// WEBPACK FOOTER //
// ./registration/creative/components/step2.jsx